// @flow
import invariant from 'invariant';
import * as React from 'react';
import type { FileUploadTypes } from 'api/shared';
import MultiInput from 'components/MultiInput';
import Field from './Field';

const MultiInputField = ({
  name,
  component,
  label,
  description,
  matchGeneralError,
  placeholder,
  maxInputs,
  type = 'text',
  disabled,
  collapsible,
  extraData,
  hideControls,
  addText,
  removeText,
  showEmpty,
  startWithNone,
  errors,
  isComplex,
  sortBy
}: {
  name: string,
  component?: React.ElementType,
  label?: string,
  description?: string,
  matchGeneralError?: string,
  placeholder?: string,
  maxInputs: number,
  type?: string,
  disabled?: boolean,
  collapsible?: boolean,
  extraData?: Array<{
    customErrorMatch?: APIErrors => ?Object,
    includeCity?: boolean,
    includeFull?: boolean,
    label?: string,
    placeholder?: string,
    isRequired?: boolean,
    fileType?: FileUploadTypes,
    onUpdateValue?: Function
  }>,
  hideControls?: boolean,
  addText?: string,
  removeText?: string,
  showEmpty?: boolean,
  startWithNone?: boolean,
  errors?: APIErrors,
  isComplex?: boolean,
  sortBy?: (
    { value: mixed, index: number },
    { value: mixed, index: number }
  ) => number
}) => (
  <Field
    name={name}
    label={label}
    description={description}
    matchGeneralError={matchGeneralError}
    renderInput={({ value, id, qaId, updateValue, hasGeneralError }) => {
      invariant(
        Array.isArray(value),
        `Invalid value for MultiInputField named ${name}: ${value}`
      );
      return (
        <MultiInput
          id={id}
          component={component}
          name={name}
          type={type}
          values={value}
          hasError={hasGeneralError}
          maxInputs={maxInputs}
          data-qa-id={qaId}
          placeholder={placeholder}
          onChange={updateValue}
          disabled={disabled}
          collapsible={collapsible}
          extraData={extraData}
          hideControls={hideControls}
          addText={addText}
          removeText={removeText}
          showEmpty={showEmpty}
          startWithNone={startWithNone}
          isComplex={isComplex}
          errors={errors}
          sortBy={sortBy}
        />
      );
    }}
  />
);

export default MultiInputField;
